/**
 * Preferences Redux Reducer
 */

import * as actions from '../actions/preferences';

import { Success } from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { getUserLanguage } from '../../locales';

type ReducerState = IPreferencesState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const initialState: ReducerState = {
  language: getUserLanguage(),
};

const setLanguageHandler: Handler<{ language: AvailableLanguages }> =
  (state, { language }) => ({
    ...state,
    language,
  });

const setPreferencesFromLocalStorageHandler: Handler<Success<void, ReducerState>> =
  (state, { result }) => result;

export default reducerWithInitialState(initialState)
  .case(actions.setLanguage, setLanguageHandler)
  .case(actions.setPreferencesFromLocalStorage.done, setPreferencesFromLocalStorageHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/preferences.ts